import React from 'react'
import "./Banner.css";
import Signup from '../auth/signup/Signup';
const Banner = () => {
    return (
        <>
            <section className="hero">
                <div className="overlay" />
                <div className='tag-text-wrapper'>
                    <div className='tag-text-conteiner'>
                        <h1 className='tag-text'>Start Learning the <br />
                            <span className="typing-text text-warning">Holy Quran </span>
                        </h1>
                        <div className='verse3'><p><span className='h-line'></span>Read! In the name of your Lord, who created</p></div>
                    </div>
                </div>
                <div className='auth-wrapper'><div className='auth'><Signup /></div></div>
            </section>
        </>
    )
}

export default Banner;